export default __webpack_public_path__ + "static/media/Mark-2-Suit-Cycles-14.51bf7a57.jpg";